import React, { useState } from 'react';
import styles from '../components/RegistrationForm.module.css';
import { StudentAPI } from './AllApi';
import Header from './Header';
import Footer from './Footer';
import { toast } from 'react-toastify';

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    studentFullName: '',
    birthDate: '',
    school: '',
    grade: '',
    parentFullName: '',
    address: '',
    mobile: '',
    email: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  
    const studentData = {
      name: formData.studentFullName,
      dob: formData.birthDate,
      school: formData.school,
      standard: formData.grade,
      parentName: formData.parentFullName,
      address: formData.address,
      mobile: Number(formData.mobile),
      email: formData.email,
    };
  
    try {
      const response = await fetch(StudentAPI.saveStudent, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(studentData),
      });
  
      const result = await response.json();
  
      if (response.ok && result.message === 'Student saved successfully.') {
        toast.success('नोंदणी यशस्वी. धन्यवाद!');
        setFormData({
          studentFullName: '',
          birthDate: '',
          school: '',
          grade: '',
          parentFullName: '',
          address: '',
          mobile: '',
          email: '',
        });
      } else if (result.message === 'Student with this mobile number already exists.') {
        toast.warning(`नोंदणी अयशस्वी: Student with this mobile number already exists.`);
      } 
      else if (result.message === 'Student with this email already exists.') {
        toast.warning(`नोंदणी अयशस्वी: Student with this email already exists.`);
      } else if (result.error) {
        toast.error(`नोंदणी अयशस्वी: ${result.error}`);
      } else {
        toast.error('नोंदणी अयशस्वी. कृपया पुन्हा प्रयत्न करा.');
      }
    } catch (error) {
      console.error('Error while saving student:', error);
      toast.info('सर्व्हरशी संपर्क होऊ शकला नाही.');
    } finally {
      setIsSubmitting(false);
    }
  };  

  return (
    <>
    <Header/>
    <div className={styles.container}>
    <div className={styles.eventInfo}>
    <strong style={{color:"rgb(249, 115, 22)", fontSize:'20px'}}>मनोरंजन मंडळ, इचलकरंजी</strong><br />
    <span style={{ fontWeight: "bold", fontSize: "18px", color:"rgb(243, 85, 37)", }}> 
    श्री. दगडुलाल मर्दा फौंडेशन<br />
    </span>
    <span style={{ fontWeight: "bold", fontSize: "16px", color:"black", }}> 
    रोटरी क्लब ऑफ इचलकरंजी सेंट्रल<br />
    </span>
    <em>आयोजित</em><br />
    <span style={{ fontWeight: "bold", fontSize: "17px", color:"black", }}>
        दहावी नंतर करिअर निवडताना.....
    </span><br />
    <strong>वक्ते: </strong><span style={{ fontWeight: "bold", fontSize: "18px", color:"rgb(248, 178, 12)", }}> 
     श्री. विवेक वेलणकर, पुणे<br />
     </span>
    <em><strong>करिअर समुपदेशक</strong></em>
    </div>
      <h3 className={styles.newheading}>नोंदणी फॉर्म</h3>

      <form onSubmit={handleSubmit} className={styles.form}>
        <label>विद्यार्थ्यांचे नाव:</label>
        <input
          type="text"
          name="studentFullName"
          placeholder="विद्यार्थ्याचे नाव"
          onChange={handleChange}
          value={formData.studentFullName}
          required
        />

        <label>पालकांचे नाव:</label>
        <input
          type="text"
          name="parentFullName"
          placeholder="पालकांचे नाव"
          onChange={handleChange}
          value={formData.parentFullName}
          required
        />

        <label>जन्मतारीख:</label>
        <input type="date" name="birthDate" onChange={handleChange}  value={formData.birthDate} required />

        <div className={styles.row}>
        <div style={{marginRight:"20px"}}>
            <label>शाळा:</label>
            <input type="text" name="school" placeholder="शाळा" onChange={handleChange}  value={formData.school} style={{marginTop:'8px'}} required />
        </div>
        <div style={{marginRight:"10px"}}>
            <label>इयत्ता:</label>
            <select name="grade" onChange={handleChange} value={formData.grade} style={{marginTop:'8px',width:'400px'}} required>
            <option value="">इयत्ता निवडा</option>
            <option value="9 वी उत्तीर्ण">9 वी उत्तीर्ण</option>
            <option value="SSC परीक्षा 2025 दिली आहे">SSC परीक्षा 2025 दिली आहे</option>
            </select>
        </div>
        </div>

        <div className={styles.row}>
        <div style={{marginRight:"20px"}}>
            <label>मोबाईल:</label>
            <input
            type="text"
            name="mobile"
            value={formData.mobile}
            onChange={(e) => {
                const value = e.target.value;
                if (/^\d{0,10}$/.test(value)) {
                handleChange(e);
                }
            }}
            inputMode="numeric"
            placeholder="मोबाईल"
            style={{marginTop:'8px'}}
            required
            />
        </div>
        <div style={{marginRight:"10px"}}>
            <label>ईमेल आयडी:</label>
            <input
            type="email"
            name="email"
            onChange={handleChange}
            placeholder="ईमेल"
            value={formData.email}
            style={{marginTop:'8px', width:'370px' }}
            required
            />
        </div>
        </div>

        <label>पत्ता:</label>
        <textarea name="address" onChange={handleChange} placeholder="पत्ता" value={formData.address} required />

        <button type="submit" className={styles.submitBtn} disabled={isSubmitting}>
          {isSubmitting ? 'सबमिट करत आहे...' : 'सबमिट करा'}
        </button>
      </form>
    </div>
    <Footer/>
    </>
  );
};

export default RegistrationForm;
